import moment from 'moment'
import React from 'react'
import DatePicker from 'react-datepicker'
import {Link} from 'react-router-dom'
import Select from 'react-select'
import Text from 'react-text'
import {faFilePdf, faChevronRight, faChevronLeft, faCalendarAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Consumer} from '../../context'
import PrintPdf from '../print-pdf'
import Duplicate from './duplicate'
import CalendarAltInput from "../date-picker/calendar-alt-input"
import { defaultDates, newPlan } from 'planning/navigation'

import './toolbar.styl'

function changeDate ({navigate, match}, view) {
  const pad = view == 'day' ? 'day' : 'week'
  return (date) => {
    const query = {
      start: moment(date).startOf(view).startOf(pad).format('YYYY-MM-DD'),
      end: moment(date).endOf(view).endOf(pad).format('YYYY-MM-DD')
    }
    navigate({}, match.path, {preserveQuery: true, query})
  }
}

export function changeView ({setState, navigate, match}, planningNavigatedFrom, planningNavigatedFromQuery) {
  return (view, query) => {
    if (planningNavigatedFrom) {
      setState({planningNavigatedFrom, planningNavigatedFromQuery})
    }
    navigate({view}, match.path, {preserveQuery: true, query})
  }
}

function title (date, level, {translate, languageId}) {
  switch (level) {
    case 'week':
      const start = moment(date).startOf(level).format('DD')
      const end = moment(date).endOf(level).format('DD')
      return `${translate('week_label')} ${start} - ${end}`
    case 'day':
      const formats = {
        es: "dddd, DD [de] MMMM [de] YYYY",
        en: "dddd, MMMM do YYYY"
      }
      return moment(date).format(formats[languageId])
    default:
      return moment(date).format('MMMM YYYY')
  }
}

export default function Toolbar (props) {
  const {date} = props
  const currentMonth = moment(date()).month()
  const monthQuery = {
    start: moment(date()).startOf('month').startOf('week').format('YYYY-MM-DD'),
    end : moment(date()).endOf('month').endOf('week').format('YYYY-MM-DD')
  }
  const level = `${props.view}s`

  return (<Consumer>{ context => {
    const {groups, action, query, languageId, planId, plans} = context
    const plan = plans.find(plan => plan.id == planId) || {}
    const navigate = changeDate(context, props.view) 
    const navigateToView = changeView(context)

    const previousDate = date().subtract(1, level)
    const nextDate = date().add(1, level)

    const previous = () => navigate(previousDate) 
    const next = () => navigate(nextDate)

    const group = context.groups.find(group => group.id == context.query.group)
    const planGroup = groups.find(group => group.id == plan.clique) || {}

    const backPath = context.link({view: context.planningNavigatedFrom},'/:languageId/:role/:page/:view',{query: context.planningNavigatedFromQuery})

    return (
      <div className="toolbar">
        { action == 'duplicate' && plan.id && planGroup.id && (<Duplicate
          plan={plan}
          group={planGroup}
        />)}
        { action == 'pdf' && (<PrintPdf
          start={query.start}
          end={query.end}
          group={group}
        />)}
        <div className="navigation">
          {props.view == 'day' && <Link className="back"  to={backPath} />}
          <div className="previous" onClick={previous}>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </div>
          </div>
          <div className="icon">
            <DatePicker
              selected={moment(date()).toDate()}
              dateFormat="MM/yyyy"
              locale={languageId}
              popperPlacement="top-end"
              popperModifiers={{
                offset: {
                  enabled: true,
                  offset: props.view == 'month' ? "158px, 5px" : "180px, 5px"
                },
                preventOverflow: {
                  enabled: true,
                  escapeWithReference: false,
                  boundariesElement: 'viewport'
                },
              }}
              onChange={date => {navigate(moment(date))}}
              customInput={<CalendarAltInput />}
              showMonthYearPicker={props.view == 'month'}
            />
          </div>
          <div className="next" onClick={next}>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <FontAwesomeIcon icon={faChevronRight} />
            </div>
          </div>
        </div>
        <div className="title">
          {title(date(), props.view, context)}
        </div>
        <div className="group">
          <Select
            className="select-group"
            classNamePrefix="select-group"
            formatOptionLabel = {({name}) => name}
            isSearchable = {false}
            isClearable = {true}
            escapeClearsValue = {true}
            getOptionValue = {({id}) => id}
            placeholder = {context.translate("group_label")}
            value = {group}
            onChange = {option => {
              const group = option ? option.id : undefined
              context.navigate({}, context.match.params, {preserveQuery: true, query: {group}})
            }}
            options = {groups}
          />
        </div>
        {props.view != 'day' && (
        <div className="button today" onClick={() => navigate(new Date())}>
          <Text id="today_label" />
        </div>
        )}
        {props.view != 'day' && (
          <div
            className={`button week ${props.view == 'week' ? 'active' : ''}`}
            onClick={() => {
              if (props.view == 'month') {
                const planningWeek = moment(context.planningWeek)
                const query = currentMonth == planningWeek.month()
                  ? {start: context.planningWeek, end: planningWeek.endOf('week').format('YYYY-MM-DD')} 
                  : {
                    start: moment(date()).startOf('month').startOf('week').format('YYYY-MM-DD'),
                    end: moment(date()).startOf('month').endOf('week').format('YYYY-MM-DD'),
                  } 
                navigateToView('week', query)
              }
            }}
          >
            <Text id="week_label" />
          </div>
        )}
        {props.view != 'day' && (
          <div
            className={`button month ${props.view == 'month' ? 'active' : ''}`}
            onClick={() => props.view != 'month' && navigateToView('month', monthQuery)}
          >
            <Text id="month_label" />
          </div>
        )}
        {props.view == 'day' && (
        <div
          className="new-plan"
          onClick={() => {
            newPlan(context, moment(props.date()).toISOString(), context.query.group)
          }}
        >
        </div>)}
        <div
          className="print-pdf"
          onClick={() => {
            context.navigate({view: context.view || 'month'}, '/:languageId/:role/:page/:view/pdf', {preserveQuery: true})
          }}
        >
          <FontAwesomeIcon icon={faFilePdf} />
        </div>
      </div>
    )}}</Consumer>)
}
